module.exports = __webpack_public_path__ + "media/images/bg/shapes/gallery/party-8c350826689fe0ab8d4aabc2c9bbdf7a.svg";